import React from 'react';
import { useActiveLeague } from '../../App';
import CampaignWizard from './CampaignWizard';

export default function CampaignCreatePage() {
    const { activeLeague } = useActiveLeague();
    return (
        <CampaignWizard
            mode="create"
            leagueId={activeLeague?.id}
            leagueName={activeLeague?.name}
        />
    );
}
